import { render, staticRenderFns } from "./PriceManagementGrid.vue?vue&type=template&id=e3843940&"
import script from "./PriceManagementGrid.vue?vue&type=script&lang=js&"
export * from "./PriceManagementGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports